module.exports = __webpack_public_path__ + "static/media/determinations_Micro.2b9f9ad2.svg";